import { BayData, DisplayMode } from '@amzn/ihm-floorplan-core';
import Box from '@amzn/meridian/box';
import { BoxMinWidth } from '@amzn/meridian/box/box';
import Table, { TableRow, TableCell } from '@amzn/meridian/table';
import React, { useCallback } from 'react';

/**
 * Returns a tooltip for a fixture based on the display modes.
 */
function useTooltipFromDisplayModes(
  displayModes: DisplayMode[],
  boxMinWidth: BoxMinWidth = '300px',
): (bay: BayData) => JSX.Element {
  const tooltip = useCallback(
    (bay: BayData) => (
      <Box type="fill" minWidth={boxMinWidth}>
        <Table showDividers spacing="small">
          {displayModes.map((dm) => (
            <TableRow key={dm.name}>
              <TableCell backgroundColor="secondary">{dm.name}</TableCell>
              <TableCell>{dm.render(bay).displayText}</TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    ),
    [displayModes, boxMinWidth],
  );

  return tooltip;
}

export default useTooltipFromDisplayModes;
